/**
 * Custom comparison logic based on prevProps and nextProps of ListCards for ListItems in SideNav Menu
 * Return true if props are equal, return false otherwise
 * @method areCardsEqual
 */
const areCardsEqual = (prevProps, nextProps, propsToCompare) => {
  if (prevProps.isSnippetLinkAvailable !== nextProps.isSnippetLinkAvailable) {
    return false;
  }

  const prevContentItem = prevProps.contentItem;
  const nextContentItem = nextProps.contentItem;

  return propsToCompare.every(
    (prop) => prevContentItem?.[prop] === nextContentItem?.[prop],
  );
};
export default areCardsEqual;
